<script>
// import { FormatPercentSales } from "../../utils";
export default {
  name: "HyperlinkSales",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    // const MetaMes = context.props.row.MontlyTarget;
    // const VentaMes = context.props.row.Totals;

    let classs = "info";

    // if (VentaMes / MetaMes / 100 <= 70) {
    //   classs = "red";
    // } else if (VentaMes / MetaMes / 100 >= 90) {
    //   classs = "green";
    // } else if (VentaMes / MetaMes / 100 >= 71 && val <= 89) {
    //   classs = "golden";
    // }

    const MothValue = function (val) {
      if (val > 0) {
        return val;
      } else {
        return "";
      }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            const { month } = context.data.attrs;
            const { /*mes, row,*/ openDetail } = context.props;

            //openDetail(mes, row);
            openDetail(context.props, month);
          }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
